import * as yup from "yup";

/**
 * Yup validation schema for setting a user's password (e.g., after account activation).
 *
 * Validates:
 * - email: Required valid email address.
 * - password: Required string with a minimum of 6 characters.
 * - password_confirmation: Required string. Must match the `password` field.
 *
 * @returns {yup.ObjectSchema<any>} Yup validation schema object.
 */
const setPasswordValidation = yup.object().shape({
  email: yup
    .string()
    .email("Ungültige E-Mail")
    .required("E-Mail ist erforderlich!"),
  password: yup
    .string()
    .required("Passwort ist erforderlich!")
    .min(6, "Das Passwort muss mindestens 6 Zeichen lang sein."),
  password_confirmation: yup
    .string()
    .required("Passwortbestätigung ist erforderlich!")
    .test(
      "password-match",
      "Die Passwörter stimmen nicht überein!",
      function (value) {
        const { password } = this.parent;
        return password === value || value === null;
      }
    ),
});

export default setPasswordValidation;
